import React from 'react'
import { connect } from 'react-redux'
import './index.scss'
import LandownerSearch from './landowner-search'
import LocationSearch from './location-search'
import Dialog from '../../common/dialog'
import ProBlocker from '../../common/pro-blocker'
import { collapseLeftToolbar } from '../../../../action/left-toolbar-state-actions'
import { userHasPro } from '../../../../lib/util'


class Search extends Dialog {
  constructor(props) {
    super(props)
    this.state = {
      selectedTab: 'location'
    }
  }

  render() {
    const { selectedTab } = this.state,
      { collapseLeftToolbar, user } = this.props,
      hasPro = userHasPro(user)

    return (
      <div
        className='left-expanded-content-container'
        style={{
          overflow: 'hidden',
          overflowX: 'hidden'
        }}
      >
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          <div className='left-expanded-header-container'>
            <span className='left-expanded-header'>Search</span>
            <div className='default-close left-dialog-close' onClick={collapseLeftToolbar}></div>
          </div>
          <div className='left-expanded-tabs-container'>
            {
              this.makeTab({
                tab: 'location',
                label: 'Location',
                active: '../../../../../asset/Search_Solid_white_ldpi.png',
                inactive: '../../../../../asset/Search_Solid_4F4F4F_ldpi.png',
              }, user.countryId === 3 ? '100%' : '50%')
            }
            {
              (
                <div style={{ width: '50%', position: 'relative', display: user.countryId === 3 ? 'none' : 'block' }}>
                  {this.makeTab({
                    tab: 'landowner',
                    label: 'Landowner',
                    active: '../../../../../asset/Search_Solid_white_ldpi.png',
                    inactive: '../../../../../asset/Search_Solid_4F4F4F_ldpi.png',
                  }, '100%')}
                  {hasPro ? null : <ProBlocker />}
                </div>
              )
            }
          </div>
          {
            selectedTab === 'location' ? <LocationSearch /> : <LandownerSearch />
          }
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  user: state.user
})

const mapDispatchToProps = dispatch => ({
  collapseLeftToolbar: () => dispatch(collapseLeftToolbar())
})

export default connect(mapStateToProps, mapDispatchToProps)(Search)